import { select, put } from "redux-saga/effects";
import {changePageSuccess, loadResponsesRequest} from "./responses-action-creators";


export default function* changePage(action) {
  const { page, previous, next } = action;
  let newPage;
  const totalPages = yield select(state => state.responses.totalPages);
  const responses = yield select(state => state.responses.responses);
  if (next) {
    newPage = page + 1;
    newPage <= totalPages ?
      responses[newPage]
        ?
        yield put(changePageSuccess(newPage))
        :
        yield put(loadResponsesRequest({page: newPage}))
      :
      null;
  }
  if (previous) {
    newPage = page - 1;
    newPage >= 1 ?
      responses[newPage]
        ?
        yield put(changePageSuccess(newPage))
        :
        yield put(loadResponsesRequest({page: newPage}))
      :
      null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/responses/change-page-saga.js